import Poi from '@/components/sl-amap/components/amap-poi'
import { getStaticPath } from '@/util/request'
import { throttle,privacy } from '@/util'
import { wgs2gcj } from '@/util/map/proj'
import { createDict } from '@/util/dicts'
import CarList from './partial/car-list'
import CourierList from './partial/courier-list'
import { getPositionByCode } from '@/components/vue-sl/city-select'
import CarDetail    from './partial/car-detail'
import global from '@/util/mixin/global'

const cache = {}

const BLACKLIST_COMPANY = location.search.includes('acl') ? [2017,2016,98,99,94,1879,68,2576].reduce((t,c) => (t[c]=1,t),{}) : {}

const BLACKLIST_BRAND_ID = [12,47].reduce((t,c) => (t[c]=1,t),{})

const ACL = (i , subject) => {
  return BLACKLIST_COMPANY[i.id] || (subject.districtCode === '330600' && !BLACKLIST_BRAND_ID[i.brandId])
}

const promiseZoom = (map, zoom , duration) => {
  return new Promise((resolve) => {
    const onZoomEnd = () => {
      map.remove('zoomend' , onZoomEnd )
      resolve()
    }
    map.on('zoomend' , onZoomEnd )
    map.setZoom(zoom,false,duration)
  })
}

const promiseSetZoomAndCenter = (map, zoom , p, duration) => {
  return new Promise((resolve) => {
    const onEnd = () => {
      map.remove('moveend' , onEnd )
      resolve()
    }
    map.on('moveend' , onEnd )
    map.setZoomAndCenter(zoom,p,false,duration)
  })
}

const convHandler = (obj) => {
  let ts = 'fn_'+(Date.now() + Math.random() + '').replace('.', '_'), c = 0
  let ret = {}
  for(let i in obj) {
    let args = (i.match(/\(([\w\W]+)\)/) || ['', ''])[1].replace(/\s/g, '').split(',').filter(i => !!i)
    let funName = i.split('(')[0]
    let globalFunName = ts + c++
    window[globalFunName] = obj[i]
    let argsStr = args.map(i => `{${i}}`).join(',')
    let globalFunNameStr = `window['${globalFunName}'](${argsStr})`
    ret[funName] = globalFunNameStr
  }
  return ret
}

import './index.scss'
export default {
  mixins:[global],
  props:['defaultId','defaultZoom','defaultAreaCode','switchZoom','disableClusterCount'],
  data() { //
    return {
      companies: [],
      companySelect:[],
      componentStats:[],
      brands: {},
      ready:false,
      map: null,
      poiManager:null,
      //<span title="{levelText}" style="position:absolute;width:6px;height:6px;border-radius:6px;right:0;top:0;box-shadow: 0 0 0 1px #fff;background:{color};transform: translate(50%,-50%);transform-origin: 100% 0;"><span>
      poiTpl: '<div class="sl-amap-poi" title="{name}"><div class="sl-amap-poi__tip" style="">{shortName}</div><i style="border:3px solid {color};background-image:url({icon})" class="company-map-poi-{level}"></i></div>',
      iwTpl: `
      <div class="sl-amap-popup">
        <h3>{name}</h3>
        <div class="sl-amap-popup-wrap">
          <div class="sl-amap-popup-thumb" style="background-image:url({icon})"></div>
          <div class="sl-amap-popup-cnt">
            <p><label>品牌：</label>{brandName}</p>
            <p><label>负责人：</label>{legalName}</p>
            <p><label>电话：</label>{companyPhone}</p>
            <p><label>地址：</label>{businessAddress}</p>
            <p>
              <a title="快递员数量" style="padding: 10px 0;" onclick="{link_to_courier_list}"><i class="ivu-icon i-icon icon-kuaidiyuan"></i>{courierTotal}</a>
              <a title="配送车数量" style="margin-left:8px;padding: 10px 0;" onclick="{link_to_car_list}"><i class="ivu-icon i-icon icon-car"></i>{carTotal}</a>
              <a style="margin-left:8px;padding: 10px 0;" onclick="{link_to_car_map}">车辆地图</a>
            </p>
            <p class="font-size:18px;">
              <a style="padding: 10px 0;{device0Style}" onclick="{link_to_company_live}"><i class="ivu-icon i-icon icon-camera"></i></a>
              <a style="padding: 10px 0;{device2Style}" onclick="{link_to_verify_live}"><i class="ivu-icon i-icon icon-credentials"></i></a>
              <a style="padding: 10px 0;{device1Style}" onclick="{link_to_open_live}"><i class="ivu-icon i-icon icon-kuaidi"></i></a>
            </p>
          </div>
        </div>
        <div class="sl-amap-popup-footer" style="{warnStatsStyle}">
          <div>预警等级:{levelText}</div>
          <div>工作:{workNum}</div>
          <!--<div>异常:{warnNum}</div>-->
          <div>休息:{restNum}</div>
        </div>
        <i class="sl-amap-popup-arrow"></i><i class="sl-amap-popup-close" onclick="{close_iw}">×</i>
      </div>`,
      visible: false,
      companyWarning:[],
      poiCluster:null,
      carListVisible:false,
      visibleCount:false,
      focusCarNo:null
    }
  },
  beforeDestroy(){
    this.poiManager.destroy()
    this.map.destroy()
  },
  created(){
    this.$watch('defaultAreaCode',function(nv){
      console.log('defaultAreaCode',nv)
      this.changeCity(nv)
    })
  },
  methods: {
    initCluster(){
      return new Promise((resolve) => {
        AMapUI.load(['ui/geo/DistrictCluster'], (DistrictCluster) => {
          resolve(DistrictCluster)
        });
      })
      
    },
    async init(map) {
      this.map = map

       let DistrictCluster = await this.initCluster()
       this.poiCluster = new DistrictCluster({
        // zIndex: 100,
        map: map,
        autoSetFitView: false,
       
        renderOptions: {
          animEnable: false,
          featureStyleByLevel: {
            country: { fillStyle: 'rgba(0,0,0,0)' },
            province: { fillStyle: 'rgba(0,0,0,0)' },
            city: { fillStyle: 'rgba(0,0,0,0)' },
            district: { fillStyle: 'rgba(0,0,0,0)' }
          },
          featureStyle: {
            lineWidth: 0
          },
          featureEventSupport: false, //区划面是否开启事件支持
          featureClickToShowSub: false, //点击区划面是否触发进入子级区划
          hoverOptions: null,
          getClusterMarker: function(feature, dataItems, recycledMarker) {
            if (this.visibleEmptyCluster || dataItems.length > 0) {
              return DistrictCluster.ClusterMarkerStrategy.DEFAULT.call(this, feature, dataItems, recycledMarker)
            }
          }

        },
        getPosition: (item) => {
          return [item.longitude, item.latitude]
        },
      });

      this.poiCluster.on('clusterMarkerClick', this.handleClusterClick.bind(this))

      this.map.on('zoomend', this.updateViewLayer.bind(this));

      this.query()
    },
    updateViewLayer() {
      // if( this.animating ) return

      let zoom = this.map.getZoom()
      if (zoom > 10) {
        //if (this.visibleCluster) {
          this.poiCluster.hide()
        //}
        this.poiManager.show()
      } else {
        //if (this.visibleCluster) {
          this.poiCluster.show()
        //}
        this.poiManager.hide()
      }
    },
    async changeCity(areacode){
      // this.fetchCompany()
      // let center = getPositionByCode(areacode)
      // let nc = new AMap.LngLat(center[0],center[1])
      // this.map.setCenter(nc)
      if( areacode == '86' ){
        this.poiManager.close()
        this.poiManager.setVisible(false)
        await promiseSetZoomAndCenter(this.map, 5 , new AMap.LngLat(108.948024, 34.263161),600)
        return
      }

      let c = this.map.getCenter()
      let dst = getPositionByCode(areacode)
      let nc = new AMap.LngLat(dst[0],dst[1])
      let mc = new AMap.LngLat(c.getLng()  + (dst[0] - c.getLng()) * 0.618,c.getLat()  + ( dst[1] - c.getLat()) * 0.618)
      let targetZoom = this.defaultZoom || this.map.getZoom()
      
      this.poiManager.close()
      this.poiManager.setVisible(false)

      await promiseSetZoomAndCenter(this.map, 6 , mc,600)
      // await promiseZoom(this.map, 6,600)
      await promiseSetZoomAndCenter(this.map, targetZoom , nc,500)
      // await promiseZoom(this.map, targetZoom ,600)
      this.poiManager.setVisible(true)

    },
    handleClusterClick(event, record) {
      if (record.feature.properties.level === "district") {
        this.map.setZoomAndCenter(this.switchZoomCalc + 1, new AMap.LngLat(...record.feature.properties.center))
      }
    },
    query() {
      
      let { map } = this

      let handlers = convHandler({
        'link_to_car_map(id)':this.linkToCar.bind(this),
        'link_to_car_list(id)':this.linkToCarList.bind(this),
        'link_to_courier_list(id)':this.linkToCourierList.bind(this),
        'link_to_company_live(device0)':this.linkToCamera.bind(this),
        'link_to_open_live(device1)':this.linkToCamera.bind(this),
        'link_to_verify_live(device2)':this.linkToCamera.bind(this)
      })

      this.poiManager = new Poi(map, {
        poiTpl: this.poiTpl,
        iwTpl: this.iwTpl,
        size: [48, 48],
        offset: [-16, -37],
        handlers:{
          ...handlers,
          convData:this.getCompanySummary.bind(this),
        }
      })

      // let { map } = this
      // let ts = Date.now()
      // let linkToCarMap = '_sl_map_linkto_carmap_' + ts
      // let linkToCarList = '_sl_map_linkto_carlist_' + ts
      // let linkToCourierList = '_sl_map_linkto_courierlist_' + ts
      // let linkToNav = '_sl_map_linkto_nav_'+ts
      // window[linkToCarMap] = this.linkToCar.bind(this)
      // window[linkToCarList] = this.linkToCarList.bind(this)
      // window[linkToCourierList] = this.linkToCourierList.bind(this)
      // window[linkToNav] = this.linkToNav.bind(this)

      // this.poiManager = new Poi(map, {
      //   poiTpl: this.poiTpl,
      //   iwTpl: this.iwTpl,
      //   size: [48, 48],
      //   offset: [-16, -37],
      //   handlers:{
      //     'link_to_car_map':`window['${linkToCarMap}']({id})`,
      //     'link_to_car_list':`window['${linkToCarList}']({id})`,
      //     'link_to_courier_list':`window['${linkToCourierList}']({id})`,
      //     'link_to_camera':`window['${linkToNav}'](1)`,
      //     'link_to_scan':`window['${linkToNav}'](2)`,
      //     'link_to_package':`window['${linkToNav}'](3)`,
      //     convData:this.getCompanySummary.bind(this)
      //   }
      // })

      map.on('moveend', this.update)
      map.on('zoomend', this.update)
      map.on('resize', this.update)

      this.map = map

      this.fetchBrand()
    },
    linkToCamera(deviceId) {
      if( deviceId ) {
        this.loading = true
        this.$request.companyDeviceLive(deviceId).then(resp => {
          this.loading = false

          if( resp.code ) {
            message.error(resp.msg)
          }else{
            this.$dialog({
              width: '80vw',
              transitionNames: ['none', 'none'],
              paddingless: true,
              footer:false,
              render: (h) => {
                let options = {
                  autoplay: true,
                  video: {
                    url: resp.data.liveAddress.replace('http:','https:'),
                    type: 'auto',
                  },
                }
                return <sl-video options={options} style="height:80vh;width:80vw;text-align:center;background:#000;"></sl-video>
              }
            })
          }
        })
      }else{
        this.$message.error('没有在线的监控设备')
      }
    },

    linkToNav(type){
      if( type == 2 || type == 3){
        this.$dialog({
          width: '80vw',
          transitionNames: ['none', 'none'],
          paddingless: true,
          render: (h) => {
            let src = `https://doc.zjtianyoukeji.com/video/${type}.mp4`
            return <div style="height:80vh;width:80vw;text-align:center;background:#000;"><video style="width:100%;height:100%;object-fit: contain;" controls="controls" autoplay="autoplay" src={src} /></div>
          }
        })
      }
    },
    getCompanySummary(d){
      this.$refs['courierlist'].init(false)
      this.$refs['carlist'].init(false)
      return this.$request.screenCompanySummary(d.id).then( resp => {
        d.carTotal = resp.data.carTotal || 0
        d.courierTotal = resp.data.courierTotal || 0
        d.workNum = resp.data.workNum || 0
        d.restNum = resp.data.restNum || 0
        d.warnNum = resp.data.warnNum || 0
        d.brandName = resp.data.brandName
        d.companyName = resp.data.companyName
        d.companyPhone = privacy(resp.data.companyPhone,'mobile')
        d.businessAddress = resp.data.businessAddress
        d.legalName = resp.data.legalName
        d.warnStatsStyle = resp.data.isOpenWarn == false ? 'display:none' : ''

        let devices = resp.data.devices
        d.device0 = (devices.find(i => i.deviceType == 0) || {})['id']
        d.device1 = (devices.find(i => i.deviceType == 1) || {})['id']
        d.device2 = (devices.find(i => i.deviceType == 2) || {})['id']

        d.device0Style = d.device0 ? '' : 'display:none'
        d.device1Style = d.device1 ? '' : 'display:none'
        d.device2Style = d.device2 ? '' : 'display:none'

        return Promise.resolve(d)
      })
    },

    update() {
      if (this.ready) {
        //this.fetchCompany(this.poiManager.getBounds(true))
        this.poiManager.update()
      }
    },

    reload(){
      let visible = this.companyWarning.filter(i => !i.disabled).map(i => i.value)
      this.poiManager.load( this.companies.filter(i => visible.includes(i.level) ) )
    },

    fetchBrand() {
      Promise.resolve(cache['brand'] || this.$request.brands(0)).then(resp => {
        if (resp.code == 0) {
          cache['brand'] = resp

          resp.data.forEach(i => {
            i.logo = getStaticPath(i.brandLogo)
          })
          this.brands = this.$utils.map(resp.data, 'id')
          this.ready = true
          this.fetchCompany()
        }
      })
    },

    onSelect(id){
      let hit = this.companies.find(i => i.id == id)
      if( hit ){
        this.poiManager.openMarker(id , 17)
      }
    },

    fetchCompany(bounds) {
      this.ready = false
      let params = { ...bounds }

      if( this.defaultAreaCode ){
        // params.code = this.defaultAreaCode
      }
      let warningDict = createDict('companyWarningStrategy').slice(0,-1).reduce((t,c,idx) => (t[c.value] = {...c , count:0} , t), [])

      const subject = this.subject
      console.log(subject)
      // this.$request.companies({ search:{} , pageSize:1e6}).then(resp => {
      Promise.resolve(cache['all'] || this.$request.screenCompanyMap(params)).then(resp => {
        if (!resp.code) {
          if(params.code){
            cache[params.code] = resp
          }else{
            cache['all'] = resp
          }
          this.companies = this.$utils.conv(resp.data || [],{'level':'companyWarningStrategy'}).filter(i => !ACL(i,subject))

          this.companies.forEach(i => {
            i.icon = this.brands[i.brandId] ? this.brands[i.brandId].logo : ''
            let t = wgs2gcj(i.lng , i.lat)
            i.longitude = t[0]
            i.latitude = t[1]
            if( warningDict[i.level] ) {
              i.color = warningDict[i.level].color
              i.levelText = warningDict[i.level].label
              warningDict[i.level].count++
            }
            // i.shortName = 'xxxx'
            if(!i.shortName) i.shortName = i.name
          })

          this.companySelect = this.companies.map(i => ({
            label:i.name,
            value:i.id
          }))

          this.companyWarning = warningDict

          this.poiManager.load(this.companies)

          this.poiCluster.setData(this.companies);

          this.ready = true

          if( this.defaultId ){
            this.onSelect(this.defaultId)
          }

          else if( window.location.search ){
            let {lat , lng , zoom = 8 } = this.$route.query
            if( lat && lng ){
              setTimeout(()=>{
                this.map.setZoomAndCenter(zoom ,  new AMap.LngLat(lng, lat))
              },800)
            }

          }

          let targetOptions = [this.map.getZoom(),this.map.getCenter()]
          if( this.defaultZoom ){
            targetOptions[0] = this.defaultZoom
          }
          if( this.defaultAreaCode ){
            let dst = getPositionByCode(this.defaultAreaCode)
            if( this.defaultAreaCode == '86' ){
              targetOptions[0] = 5
              this.poiManager.hide()
            }
            targetOptions[1] = new AMap.LngLat(dst[0],dst[1])
          }

          this.map.setZoomAndCenter(...targetOptions)

        }
      })
    },
    handleModal() {
      setTimeout(this.update, 1000)
    },
    handleToggle(i , idx){
      let { companyWarning } = this
      i.disabled = !i.disabled
      this.companyWarning.splice(idx , 1 , i)

      this.reload()
    },
    linkToCar(companyId){
      this.$router.setRouteByCode('car.map.new' , {query:{companyId}},true)
    },
    linkToCarList(companyId){
      let hit = this.companies.find(i => i.id == companyId)
      this.$refs['courierlist'].init(false)
      this.$refs['carlist'].init(hit)
      // console.log('linkToCarList')
    },
    linkToCourierList(companyId){
      let hit = this.companies.find(i => i.id == companyId)
      this.$refs['carlist'].init(false)
      this.$refs['courierlist'].init(hit)
    },
    handleToggleCount(){
      this.visibleCount = !this.visibleCount
    },
    handleShowCar(e){
      this.focusCarNo = e
    },
    handleCloseDetail() {
      this.focusCarNo = null
    },
  },
  render(){
    let selectNode = null
    let companyWarning = this.companyWarning || []
    return <div style="width:100%;height:100%;" class={{'company-map':1,'hide-count':(this.disableClusterCount && !this.visibleCount) ? 1 : null}}>
      <sl-amap class="map" view-mode="2D" theme="whitesmoke" zoom={4} on-ready={this.init} />
      <sl-amap-toolbar map={this.map} />
      <div class={{'company-map-control':1}}>
        <div class="company-map-control-search">
          <sl-select loading={!this.ready} filterable={true} dict={this.companySelect} on-change={this.onSelect} placeholder="搜索 企业" />
          <Icon title="显示企业统计" size="20" on-click={this.handleToggleCount} class={{'company-map-stats':1,'company-map-stats--enable':this.visibleCount}} type="md-stats" />
          {/*<Icon size="20" class={{'company-map-refresh':true,'company-map-loading':!this.ready}} type="md-refresh"  />*/}
        </div>
        <div class="company-map-stats">
          {
            companyWarning.map((i,idx) => (
              <div class={{'company-map-stat':1,'disabled':i.disabled}} on-click={() => this.handleToggle(i,idx)}>
                <div style="display:flex;align-items:center;justify-content: center;"><i style={{'borderColor':i.color}}></i>{i.count}家</div>
                <div>{i.label}</div>
              </div>
            ))
          }
        </div>
        <CarDetail show-close={true} on-close={this.handleCloseDetail} class="map-car-detail" style="margin-top:10px;" carNo={this.focusCarNo} location={this.focusCarLocation} />
      </div>
      <CarList ref="carlist" autoUpdate={true} on-show={this.handleShowCar} />
      <CourierList ref="courierlist" />

    </div>
  }
}